import { FilterableField } from 'module/types/filter-field/field/filterable-field';
import { getRenderer as getRendererBase } from 'module/ui/components/molecules/ag-grid-renderer/ag-grid-renderer';
import { NameCell } from './name-cell';
import { PeopleDefaultColumnFields } from '../use-static-column-fields';
import {
  RecentOpportunitiesCell,
  RecentRisksCell,
} from './recent-signal-types';

export const getRenderer = (field: FilterableField) => {
  switch (field.fieldName) {
    case PeopleDefaultColumnFields.Name:
      return NameCell;
    case PeopleDefaultColumnFields.RecentRisks:
      return RecentRisksCell;
    case PeopleDefaultColumnFields.RecentOpportunities:
      return RecentOpportunitiesCell;
    default:
      return getRendererBase(field);
  }
};
